// WP URLs
export const WP_URLS = {
  PRIVACY_POLICY: 'https://reklaimyours.com/privacy-policy',
  TERMS_AND_CONDITIONS: 'https://reklaimyours.com/terms-and-conditions',
  HOW_TO_EARN: 'https://reklaimyours.com/how-to-earn',
  CONTACT_US: 'https://reklaimyours.com/contact-us',
  NOTICE_OF_INCENTIVE: 'https://reklaimyours.com/notice-of-incentive',
}

// Social Media
export const SOCIAL_MEDIA_URLS = {
  TWITTER: 'https://twitter.com/reklaimyours',
  FACEBOOK: 'https://facebook.com/ReklaimYours',
  INSTAGRAM: 'https://instagram.com/reklaimyours',
  LINKED_IN: 'https://linkedin.com/company/reklaim',
}

// Intercom Knowledge Base URLs
export const INTERCOM_KB_URLS = {
  SUPPORTED_REGIONS: 'https://help.reklaimyours.com/en/articles/4936561-what-countries-does-killi-support',
  MULTIPLE_DEVICES:
    'https://help.reklaimyours.com/en/articles/6093569-i-can-t-redeem-because-my-account-can-only-be-logged-into-one-device',
  CASHBACK_BROWSER_EXTENSION:
    'https://help.reklaimyours.com/en/articles/5962440-what-is-the-reklaim-cashback-browser-extension',
}

export const STORE_URLS = {
  BROWSING_EXTENSION: 'https://chrome.google.com/webstore/detail/reklaim/ikhibgnidhpmkjgndcheniaakdibpjnn',
}

export const EXTERNAL_URLS = {
  REKLAIM_PROTECT: 'https://ai.reklaimyours.com',
  JSON_PARSER: 'https://jsonformatter.org/json-parser',
}

export const APP_LINK = process.env.REACT_APP_BRANCH_LINK_CUSTOM_DOMAIN

// App URLS
export const APP_URLS = {
  ROOT: '/',
  LANDING_PAGE: '/download',
  SIGN_IN: '/sign-in',
  SIGN_IN_VERIFY_CODE: '/verify-code',
  LATENT_ACTIVATION: '/latent-activation',
  CREATE_ACCOUNT: '/create-account',
  SIGN_UP: '/sign-up',
  PRIVACY_SIGN_UP: '/sign-up/privacy/form',
  COMPENSATION_SIGN_UP: '/sign-up/compensation/form',
  COMPENSATION_SIGN_UP_EXPLAINER: '/sign-up/compensation/explainer',
  PRIVACY_SIGN_UP_EXPLAINER: '/sign-up/privacy/explainer',
  SIGN_UP_EMAIL_VERIFICATION: '/signup-email-verification',
  SIGN_UP_PHONE_VERIFICATION: '/signup-phone-verification',
  REKLAIM: '/reklaim',
  MY_DATA: '/my-data',
  MY_DATA_PROFILE: '/my-data/profile',
  MY_DATA_BROWSING: '/my-data/browsing',
  MY_DATA_SHOPPING: '/my-data/shopping',
  MY_DATA_SHOPPING_CONNECT: '/my-data/shopping/connect',
  MY_DATA_DEVICE: '/my-data/device',
  MY_FOOTPRINT: '/my-footprint',
  POLLS: '/polls',
  HISTORY: '/history',
  ACCOUNT: '/account',
  SIGN_OUT: '/sign-out',
  REFER_A_FRIEND: '/refer-a-friend',
  SURVEY_COMPLETION: '/survey-completion',
  NETWORK_ERROR: '/network-error',
  KILLI_POLL: '/polls/poll',
  LOCKED: '/locked',
  FULL_UNVEIL: '/unveil',
  JACKPOT: '/jackpot',
  PROTECT: '/protect',
  PROTECT_SIGNING: '/protect/signing',
  STORE: '/store',
  WALLET: '/wallet',
  WALLET_REDEMPTIONS: '/wallet/redemptions',
  GIFT_CARD_REDEMPTION: '/wallet/redemptions/gift-card',
  CRYPTO_REDEMPTION: '/wallet/redemptions/crypto',
  SHARES_FOR_REDEMPTION: '/wallet/redemptions/shares',
  SHARES_FOR_REDEMPTION_SIGNING: '/wallet/redemptions/shares/signing',
  SHARES_FOR_REDEMPTION_SUBMITTED: '/wallet/redemptions/shares/submitted',
  REDEMPTION_SOCIAL_SHARE: '/wallet/redemptions/share',
  UNVEIL_SCANNING: '/unveil-scanning',
  UNVEIL_SUMMARY: '/unveil-summary',
  UNVEIL_DATA_NOT_FOUND: '/unveil-data-not-found',
  UNVEIL_BREACH_NOTIFICATION_EXPLAINER: '/unveil-breach-notification-explainer',
  UNVEIL_VPN_EXPLAINER: '/unveil-vpn-explainer',
  SUBSCRIPTION: '/subscription',
  EARN_MORE: '/earn-more',
}
